export default __webpack_public_path__ + "static/media/_not-saved-post-icon.8024768f.svg";